import global from './global'
// import productController from './pages/product'
import singleProductController from './pages/single-product'
import singlePostController from './pages/single-post'
import testVisaController from './pages/test-visa'
import checkoutController from './pages/checkout'
import myAccountController from './pages/my-account'

import productList from './elementor/product-list'
import blogList from './elementor/blog-list'
import cateSlider from './elementor/category-slider'
import testimonial from './elementor/testimonial'

const controllers = {
	single_post: singlePostController,
	single_product: singleProductController,
	test_visa: testVisaController,
	checkout: checkoutController,
	my_account: myAccountController
}

const _find = (_class, _str) => {
	if (_class.length > 0) {
		let _array = null
		for (let i = 0; i < _class.length; i++) {
			const n = _class[i].indexOf(_str)
			if (n > 0) {
				_array = _class[i].replace('_' + _str, '')
				break
			}
		}
		return _array
	} else {
		return null
	}
}

const router = () => {
	const _class = document.body.className.replace(/-/g, '_').split(/\s+/)
	const controller = _find(_class, 'vs')
	new global()
	// productTab()
	if (controller !== null) {
		if (controllers[controller]) {
			new controllers[controller]()
		}
	}
	//load elementor lib
	jQuery(window).on('elementor/frontend/init', () => {
		productList()
		blogList()
		cateSlider()
		testimonial()
	})
}
router()
